import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '@app/core/Services';
import { CheckPrevalidationErrors } from '@app/core/Store';
import { Store } from '@ngxs/store';
export interface ReportElement {
  number: string;
  warning: string;
  link: string;
}

const ELEMENT_DATA: ReportElement[] = [
  {
    number: '1',
    warning: 'B/fwd amounts have been used in the set of accounts and are not entered trial balance for the previous year',
    link: 'Resolve',
  },
  {
    number: '2',
    warning: 'B/fwd amounts have been used in the set of accounts and are not entered trial balance for the previous year',
    link: 'Resolve',
  },
];

@Component({
  selector: 'app-validate-report',
  templateUrl: './validate-report.component.html',
  styleUrls: ['./validate-report.component.scss']
})
export class ValidateReportComponent implements OnInit {
  displayedReportColumns: string[] = ['number', 'warning'];
  dataReportSource: any[];
  @Input() recordId: any;
  @Input() accountingPeriodId: any;
isErroeExit:boolean=false;

  constructor(private store: Store, private commonService: CommonService) {  }

  ngOnInit(): void {
    this.checkPrevalidationErrors();
  }

  checkPrevalidationErrors(): void{
    this.store.dispatch(new CheckPrevalidationErrors(this.recordId, this.accountingPeriodId)).pipe().subscribe(
      (response: any) => {
        this.dataReportSource = response?.SubmitCompanyHouse?.reports;
        this.isErroeExit=this.dataReportSource.some((item:any)=>item.type === 'Error');
      }
    );
  }

}
